import { Component, OnInit } from '@angular/core';
import { Embalagem } from 'src/app/models/embalagem';
import { FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from "@angular/forms";
import { MaskedNumber } from "imask";
import { ActivatedRoute, Router } from '@angular/router';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { CarregandoService } from 'src/app/services/carregando.service';
import { EmbalagemService } from 'src/app/services/embalagem.service';

@Component({
  selector: 'app-cadastrar-embalagem',
  templateUrl: './cadastrar-embalagem.component.html',
  styleUrls: ['./cadastrar-embalagem.component.scss']
})
export class CadastrarEmbalagemComponent implements OnInit {
  idEmbalagem;
  embalagemPadrao: Embalagem = {
    id: 0,
    descricao: '',
    tipoEmbalagem: 0,
    status: 1,
    largura: 0,
    altura: 0,
    comprimento: 0,
    peso: 0,
    margemSeguranca: 0,
    descTipoEmbalagem: 'Pallet'
  }
  embalagemFormControl: FormGroup;
  embalagemFormData: FormGroup;
  editando = false;
  statusCadastroModel = [{ id: 0, nome: 'Bloqueado' }, { id: 1, nome: 'Ativo' }];
  tipoEmbalagem = [{ id: 0, nome: 'Pallet' }, { id: 1, nome: 'Caixa' }, { id: 2, nome: 'Cilindro' }];
  tipoEmbalagemSelecionado = 0;
  exibirDimensoesCilindro: boolean = true;

  public readonly MaskedNumber = MaskedNumber;

  constructor(
    private route: ActivatedRoute,
    private notificacaoService: NotificacaoService,
    private embalagemService: EmbalagemService,
    private router: Router,
    private carregandoService: CarregandoService
  ) {
    this.createReactiveForm();
  }

  ngOnInit() {
    if (this.route.snapshot.paramMap.get('id')) {
      this.idEmbalagem = this.route.snapshot.paramMap.get('id');
      this.editando = true;
      this.buscarEmbalagem();
    } else {
      this.embalagemFormControl.reset();
      this.embalagemFormData.reset(this.embalagemPadrao);
    }
  }

  createReactiveForm() {
    this.embalagemFormData = new FormGroup({
      id: new FormControl(this.embalagemPadrao.id),
      descricao: new FormControl(this.embalagemPadrao.descricao, Validators.required),
      descTipoEmbalagem: new FormControl(this.embalagemPadrao.descTipoEmbalagem),
      status: new FormControl(this.embalagemPadrao.status, Validators.required),
      tipoEmbalagem: new FormControl(this.embalagemPadrao.tipoEmbalagem, [Validators.required]),
      largura: new FormControl(this.embalagemPadrao.largura, [Validators.required, Validators.min(0)]),
      altura: new FormControl(this.embalagemPadrao.altura, [Validators.required, Validators.min(0)]),
      comprimento: new FormControl(this.embalagemPadrao.comprimento, [Validators.required, Validators.min(0)]),
      peso: new FormControl(this.embalagemPadrao.peso, [Validators.required, Validators.min(0)]),
      margemSeguranca: new FormControl(this.embalagemPadrao.margemSeguranca, [Validators.required, Validators.min(0)]),
    }, {});
  }

  buscarEmbalagem() {
    this.carregandoService.mostra('buscarEmbalagem');

    this.embalagemService.buscar(this.idEmbalagem).subscribe((embalagem) => {
      this.embalagemFormData.setValue({
        ...embalagem,
        largura: embalagem.largura.toString(),
        altura: embalagem.altura.toString(),
        comprimento: embalagem.comprimento.toString(),
        peso: embalagem.peso.toString(),
        margemSeguranca: embalagem.margemSeguranca.toString(),
      });

      this.carregandoService.esconde('buscarEmbalagem');
    }, (erro) => {
      this.carregandoService.esconde('buscarEmbalagem');
      this.notificacaoService.erro(erro);
    });
  }

  salvar() {
    this.carregandoService.mostra('salvaEmbalagem');
    const embalagem = this.embalagemFormData.getRawValue();

    this.embalagemService.salvar(embalagem).subscribe(() => {
      this.notificacaoService.sucesso('Embalagem salva com sucesso!!!');
      this.router.navigate(['configuracoes/embalagem']).then(() => {
        this.carregandoService.esconde('salvaEmbalagem');
      });

    }, (erro) => {
      this.carregandoService.esconde('salvaEmbalagem');
      this.notificacaoService.erro(erro);
    });
  }

  verificaImagem() {
    const embalagemSelecionada = this.embalagemFormData.get('tipoEmbalagem').value;

    return `./assets/img/${embalagemSelecionada === 0 ? 'pallet' : embalagemSelecionada === 1 ? 'caixa' : 'cilindro'}.jpg`;
  }

  exibeComprimento() {
    this.exibirDimensoesCilindro = this.embalagemFormData.get('tipoEmbalagem').value == 0 || this.embalagemFormData.get('tipoEmbalagem').value == 1;
  }
}
